import { CustomButton, showToaster, toasterTypes } from '../../widgets'
import { Col, Row } from 'reactstrap'
import ModalComponent from '../common/Modal/modal'
import { FIELD_TYPES, FieldItem } from '../../widgets/fields';
import { ValidationRulesElements } from './FormElements';
import useFieldItem from '../../widgets/fields/UseFieldItem';
import { useEffect, useMemo, useState } from 'react';
import { addValidationRule, getFormVariables, updateValidationRule } from './apiController';
import { setLoading } from '../../store/slices/auth';
import { useDispatch } from 'react-redux';

interface DropDownValues {
    label: string;
    value: string;
    type?: string;
    values?: any;
}

const CreateValidationRule = (props) => {
    console.log(props)
    const { projectData, onClose, forms, groupData, groups, isUpdate, previousState } = props;
    const [values, fields, handleChange, { validateValues, updateValue, updateError, removeErrors }] = useFieldItem(ValidationRulesElements, {}, { onValueChange });
    const [parentFormsValues, setParentFormsValues] = useState<DropDownValues[]>([]);
    const [childFormsValues, setChildFormsValues] = useState<DropDownValues[]>([]);
    const [parentFormFieldsValues, setParentFormFieldsValues] = useState<DropDownValues[]>([]);
    const [childFormFieldsValues, setChildFormFieldsValues] = useState<DropDownValues[]>([]);
    const [parentFormFields, setParentFormFields] = useState<any>([]);
    const [childFormFields, setChildFormFields] = useState<any>([]);
    const [lifeCycleData, setLifeCycleData] = useState<any>([]);
    const dispatch = useDispatch();

    /**
     * create drop down values
     * @param data 
     * @param dataType 
     * @returns 
     */
    function createDropDownValues(data, dataType = "form") {
        let dropDownValues: DropDownValues[] = [];
        if (dataType === "form") {
            data.map((d, i) => {
                let Obj: DropDownValues = {
                    label: d.form_name.trim(),
                    value: d.id,
                }
                dropDownValues.push(Obj)
            }
            )
        }
        else if (dataType === "field") {
            data.map((d, i) => {
                let Obj: DropDownValues = {
                    label: d.field_name.trim(),
                    value: d.id,
                    type: d.field_type,
                    values: d.field_value
                }
                dropDownValues.push(Obj)
            })
        }
        console.log(dropDownValues)
        return dropDownValues;
    }

    /**
     * get form drop down values
     */
    function getFormDropDownValues() {
        const parentFormVals = createDropDownValues(forms, "form");
        const childFormVals = createDropDownValues(forms, "form");
        setParentFormsValues(parentFormVals);
        setChildFormsValues(childFormVals);
        return { parentFormVals, childFormVals };
    }

    /**
     * get form fields values
     */
    async function getFormFieldsValues(formId = null, formType: any = null) {
        if (formType === "parentForm") {
            let parentFormFields: any[] = [];
            let response: any;
            dispatch(setLoading(true));
            try {
                response = await getFormVariables(formId);
            } catch (error) {
                showToaster(toasterTypes.ERROR, "Something went wrong while fetching variables.");
            } finally {
                dispatch(setLoading(false));
            }
            parentFormFields = response?.data || [];
            setParentFormFields(response?.data || [])
            setParentFormFieldsValues(createDropDownValues(parentFormFields, "field"));
            return createDropDownValues(parentFormFields, "field");
        }

        if (formType === "childForm") {
            let childFormFields: any[] = [];
            let response: any;
            dispatch(setLoading(true));
            try {
                response = await getFormVariables(formId);
            } catch (error) {
                showToaster(toasterTypes.ERROR, "Something went wrong while fetching variables.");
            } finally {
                dispatch(setLoading(false));
            }
            childFormFields = response?.data || [];
            setChildFormFields(response?.data || [])
            setChildFormFieldsValues(createDropDownValues(childFormFields, "field"));
            return createDropDownValues(childFormFields, "field");
        }

        return [];
    }

    /**
     * Initialize form with previous state if in update mode
     */
    async function initializeWithPreviousState() {
        if (!previousState || !isUpdate) return;

        // Get forms dropdown values first
        const { parentFormVals, childFormVals } = getFormDropDownValues();

        // Find parent form object from forms dropdown
        const parentFormObj = parentFormVals.find(form => form.value === previousState.parent_form_id);
        const childFormObj = childFormVals.find(form => form.value === previousState.child_form_id);

        if (!parentFormObj || !childFormObj) {
            console.error("Could not find parent or child form in dropdown values");
            return;
        }

        // Get parent field values
        const parentFieldsList = await getFormFieldsValues(previousState.parent_form_id, "parentForm");
        const childFieldsList = await getFormFieldsValues(previousState.child_form_id, "childForm");

        // Find parent field object from parent fields dropdown
        const parentFieldObj: any = parentFieldsList.find(field => field.value === previousState.parent_field_ids[0]);
        const childFieldObj: any = childFieldsList.find(field => field.value === previousState.child_field_ids[0]);

        if (!parentFieldObj || !childFieldObj) {
            console.error("Could not find parent or child field in dropdown values");
            return;
        }

        // Create validation type object
        const validationObj = ValidationRulesElements.validation.values.find(
            val => val.value === previousState.validation
        );

        const allowedValues = previousState?.allowed_values?.map((val) => (
            { label: val, value: val }
        ))
        const allowedValsOptions = previousState?.life_cycle_check
        if (allowedValsOptions) {
            setLifeCycleData(allowedValsOptions)
        }


        // Update all values at once
        updateValue({
            parentForm: parentFormObj,
            childForm: childFormObj,
            parentFormFields: parentFieldObj,
            childFormFields: childFieldObj,
            validation: validationObj,
            value: previousState.value ? previousState.value.toString() : "",
            allowed_values: allowedValues,
        });
    }

    useEffect(() => {
        if (previousState && isUpdate) {
            initializeWithPreviousState();
        } else {
            getFormDropDownValues();
        }
    }, [forms]);

    /**
    * on value change for form fields
    * @param name 
    * @param value 
    * @param values 
    * @param fieldValues 
    * @returns 
    */
    function onValueChange(name, value, values, fieldValues = null) {
        let resetValue = {};
        console.log(value)
        if (name === "parentForm" || name === "childForm") {
            getFormFieldsValues(value?.value, name);
        }
        if ((parentFormFields && parentFormFields.length > 0) && (childFormFields && childFormFields.length > 0)) {
            let temp = parentFormFields?.find((field) => field.id === values?.parentFormFields?.value);
            const lifeCycleObj: any = temp?.field_value?.map((val) => (
                { value: val, is_repetative: false }
            ));
            console.log(lifeCycleObj)
            if (lifeCycleObj) {
                setLifeCycleData(lifeCycleObj);
            }
        }
        return [
            {
                ...values,
                ...resetValue,
                [name]: value,
            },
        ];
    }

    function validateFieldTypes() {
        return values.parentFormFields.type !== values.childFormFields.type;
    }

    function allowedValuesValidation() {
        return !((values.parentForm.value === values.childForm.value) && (values.parentFormFields.value === values.childFormFields.value));
    }

    async function submitValidationRules() {
        if (validateValues(["parentForm", "childForm", "parentFormFields", "childFormFields", "validation"])) {
            showToaster(toasterTypes.ERROR, "Please enter the proper values in the fields highlighted in red");
            return;
        }
        if (values.validation?.value === "value_relationship") {
            if (validateValues(["value"])) {
                showToaster(toasterTypes.ERROR, "Please enter the proper values in the fields highlighted in red");
                return;
            }
        }
        if (values.validation?.value === "lifecyclecheck") {
            if (validateValues(["allowed_values"])) {
                showToaster(toasterTypes.ERROR, "Please enter the proper values in the fields highlighted in red");
                return;
            }
        }
        if (validateFieldTypes()) {
            showToaster(toasterTypes.ERROR, "Parent and Child Form Fields should be of same Field Type");
            return;
        }
        if (values.validation?.value === "lifecyclecheck" && allowedValuesValidation()) {
            showToaster(toasterTypes.ERROR, "Parent and Child Form should be same Form. Parent and child Fields should be same.");
            return;
        }
        let reqObj: any = {
            topicid: projectData.TopicID,
            project_id: projectData.id,
            form_group_id: groupData.id,
            validation: values.validation?.value,
            parent_field: [values.parentFormFields.label],
            child_field: [values.childFormFields.label],
            parent_field_ids: [values.parentFormFields.value],
            child_field_ids: [values.childFormFields.value],
            parent_form_id: values.parentForm.value,
            child_form_id: values.childForm.value,
        }
        // let temp = parentFormFields.find((field) => field.id === values.parentFormFields.value);
        // const allowedValues = temp?.field_value;
        // 
        const allowedValues = values?.allowed_values?.map((val) => (val.value));
        if (allowedValues) {
            reqObj.allowed_values = allowedValues;
        }
        if (values.value) {
            reqObj.value = Number(values?.value);
        }
        if (lifeCycleData) {
            reqObj.life_cycle_check = lifeCycleData
        }
        if (isUpdate) {
            reqObj.id = previousState?.id || ""
        }
        dispatch(setLoading(true));
        try {
            let response: any;
            if (isUpdate) {
                response = await updateValidationRule(reqObj);
            } else {
                response = await addValidationRule(reqObj);
            }
            console.log(response)
            if (response.success) {
                showToaster(toasterTypes.SUCCESS, response?.message || `${isUpdate ? "Updated" : "Added"} Validation Rule`);
            }
            onClose();

        } catch (error) {
            showToaster(toasterTypes.ERROR, `Failed To ${isUpdate ? "Update" : "Add"} Validation Rule`);
        } finally {
            dispatch(setLoading(true));
        }
    }

    const handleLifeCycleChange = (value, index) => {
        setLifeCycleData(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                is_repetative: value
            };
            return updated;
        });
    }

    return (
        <ModalComponent
            width={"80%"}
            isOpen={true}
            onClose={() => onClose()}
            header={`${isUpdate ? "Update" : "Add"} Validation Rule`}
            centered={true}
            customClass='add-validation-rule-modal'
            body={
                <>
                    <Row>
                        <Col md={6}>
                            <FieldItem
                                {...ValidationRulesElements.parentForm}
                                value={values.parentForm}
                                values={parentFormsValues}
                                onChange={(...e) => handleChange(ValidationRulesElements.parentForm.name, ...e)}
                                touched={fields.parentForm && fields.parentForm.hasError}
                                error={fields.parentForm && fields.parentForm.errorMsg}
                            />
                        </Col>
                        <Col md={6}>
                            <FieldItem
                                {...ValidationRulesElements.childForm}
                                value={values.childForm}
                                values={childFormsValues}
                                onChange={(...e) => handleChange(ValidationRulesElements.childForm.name, ...e)}
                                touched={fields.childForm && fields.childForm.hasError}
                                error={fields.childForm && fields.childForm.errorMsg}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FieldItem
                                {...ValidationRulesElements.parentFormFields}
                                value={values.parentFormFields}
                                values={parentFormFieldsValues}
                                onChange={(...e) => handleChange(ValidationRulesElements.parentFormFields.name, ...e)}
                                touched={fields.parentFormFields && fields.parentFormFields.hasError}
                                error={fields.parentFormFields && fields.parentFormFields.errorMsg}
                            />
                        </Col>
                        <Col md={6}>
                            <FieldItem
                                {...ValidationRulesElements.childFormFields}
                                value={values.childFormFields}
                                values={childFormFieldsValues}
                                onChange={(...e) => handleChange(ValidationRulesElements.childFormFields.name, ...e)}
                                touched={fields.childFormFields && fields.childFormFields.hasError}
                                error={fields.childFormFields && fields.childFormFields.errorMsg}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FieldItem
                                {...ValidationRulesElements.validation}
                                value={values.validation}
                                onChange={(...e) => handleChange(ValidationRulesElements.validation.name, ...e)}
                                touched={fields.validation && fields.validation.hasError}
                                error={fields.validation && fields.validation.errorMsg}
                            />
                        </Col>
                        {values.validation?.value === "value_relationship" &&
                            <Col md={6}>
                                <FieldItem
                                    {...ValidationRulesElements.value}
                                    value={values.value}
                                    onChange={(...e) => handleChange(ValidationRulesElements.value.name, ...e)}
                                    touched={fields.value && fields.value.hasError}
                                    error={fields.value && fields.value.errorMsg}
                                />
                            </Col>}
                    </Row>
                    {values.validation?.value === "lifecyclecheck" && <Row><Col md={12}><div className='repetitive-text'>Select Yes for Repetitive and No for Non-Repetitive</div> </Col></Row>}
                    <Row>
                        {values.validation?.value === "lifecyclecheck" &&
                            lifeCycleData?.length > 0 && lifeCycleData?.map((obj, index) => (
                                <Col md={4}>
                                    <FieldItem
                                        name={obj.value}
                                        label={obj.value}
                                        type={FIELD_TYPES.RADIO_BUTTON}
                                        value={obj.is_repetative}
                                        values={[
                                            { label: 'Yes', value: true },
                                            { label: 'No', value: false }
                                        ]}
                                        isListed={true}
                                        isMandatory={true}
                                        onChange={(...e) => handleLifeCycleChange(...e, index)}
                                        touched={fields.allowed_values && fields.allowed_values.hasError}
                                        error={fields.allowed_values && fields.allowed_values.errorMsg}
                                    />
                                </Col>
                            ))
                        }
                    </Row>
                </>
            }
            footer={
                <div>
                    <CustomButton
                        type="primary"
                        isDisabled={false}
                        text={`${isUpdate ? "Update" : "Add"}`}
                        onClick={() => submitValidationRules()}
                    ></CustomButton>
                </div>
            }
        />
    )
}

export default CreateValidationRule